import type { SensorReading, SensorTimeSeries, SensorType } from '@grosync/common';
import { apiRequest } from './client';

export interface SensorDataPage {
  items: SensorReading[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface SensorDataFilter {
  deviceId?: string;
  sensorType?: SensorType;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

export interface TimeSeriesFilter {
  deviceId: string;
  sensorType: SensorType;
  from: string;
  to: string;
  interval?: string;
}

export function fetchSensorData(filter: SensorDataFilter): Promise<SensorDataPage> {
  const params = new URLSearchParams();
  if (filter.deviceId)   params.set('deviceId',   filter.deviceId);
  if (filter.sensorType) params.set('sensorType', filter.sensorType);
  if (filter.from)       params.set('from',       filter.from);
  if (filter.to)         params.set('to',         filter.to);
  if (filter.page)       params.set('page',       String(filter.page));
  if (filter.pageSize)   params.set('pageSize',   String(filter.pageSize));
  return apiRequest<SensorDataPage>(`/api/sensors/data?${params}`);
}

export function fetchTimeSeries(filter: TimeSeriesFilter): Promise<SensorTimeSeries[]> {
  const params = new URLSearchParams({
    deviceId:   filter.deviceId,
    sensorType: filter.sensorType,
    from:       filter.from,
    to:         filter.to,
    interval:   filter.interval ?? '1 hour',
  });
  return apiRequest<SensorTimeSeries[]>(`/api/sensors/timeseries?${params}`);
}

export const fetchRecentAlerts = async (): Promise<SensorReading[]> => {
  const from = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
  const to = new Date().toISOString();
  const params = new URLSearchParams({ from, to, pageSize: '200', page: '1' });
  const res = await apiRequest<{ items: SensorReading[]; total: number }>(
    `/api/sensors/data?${params.toString()}`,
  );
  return res.items.filter((r) => r.anomaly !== 'normal');
};
